import { DeliveryType } from '@libs/core';

export const AUTOSHIP_DELIVERIES = {
    [DeliveryType.BOPIS]: `${DeliveryType.BOPIS} ${DeliveryType.AUTOSHIP}`,
    [DeliveryType.SDD]: `${DeliveryType.SDD} ${DeliveryType.AUTOSHIP}`,
    [DeliveryType.STH]: `${DeliveryType.STH} ${DeliveryType.AUTOSHIP}`,
} as const;
